import { IconButton } from '@material-ui/core';

export const IconButtons = ({ children, ...props }) => {
  return (
    <IconButton
      sx={{
        width: {
          xs: '30px',
          md: '40px',
          lg: '60px'
        },
        height: {
          xs: '30px',
          md: '40px',
          lg: '60px'
        },
        alignSelf: 'center',
        marginLeft: {
          xs: '4px!important',
          lg: '16px!important'
        },
        padding: {
          lg: '8px',
          xs: 0
        }
      }}
      {...props}>
      {children}
    </IconButton>
  );
};
